import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8736fdfc")

_pushScopeId("data-v-8736fdfc")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传图片")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")

  return (_openBlock(), _createBlock(_component_el_upload, {
    action: _ctx.fileUploadPath,
    "before-upload": _ctx.beforeUpload,
    headers: _ctx.tokenHeader,
    multiple: _ctx.multiple,
    "on-error": _ctx.handleUploadError,
    "on-success": _ctx.handleUploaded,
    "show-file-list": false,
    accept: "image/*",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    default: _withId(() => [
      (!_ctx.showUploading)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            loading: _ctx.showUploading,
            class: "margin-left-10 margin-right-10",
            i: "el-icon-plus",
            type: "primary"
          }, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["action", "before-upload", "headers", "multiple", "on-error", "on-success"]))
})